import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { userState } from "../../../../states/userState";
import classes from "./DateEnableSwitch.module.scss";
import { Switch } from "@mui/material";
import {
  foreColor,
  foreColorCode,
  foreColorCodeDisabled,
  foreColorCodePagination,
  foreColorPagination,
} from "../../../../commons/colors";
import { setUserToLocalStorage } from "../../../../functions/localStorageManager";

const DateEnableSwitch = (props) => {
  const [user, setUser] = useRecoilState(userState);
  const { checked, setChecked } = props;

  const handleChange = (e) => {
    setChecked(e.target.checked);
    setUser((prevUser) => {
      const updatedUser = {
        ...prevUser,
        filters: {
          ...prevUser.filters,
          drawingUpdFrm: "",
          drawingUpdTo: "",
          isUpdateEnable: e.target.checked,
        },
      };
      setUserToLocalStorage(updatedUser);
      return updatedUser;
    });
  };
  return (
    <div className={classes.switch}>
      <p
        style={{
          color: checked
            ? foreColorCodePagination(user?.mode ?? "lite")
            : foreColorCodeDisabled(user?.mode ?? "lite"),
        }}
      >
        図面更新日
      </p>
      <Switch
        checked={checked}
        onChange={handleChange}
        sx={{
          "& .MuiSwitch-switchBase.Mui-checked": {
            color: foreColorCodePagination(user?.mode ?? "lite"),
            // "&:hover": {
            //   backgroundColor: foreColorCodePagination(user?.mode ?? "lite"),
            // },
          },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: foreColorCode(user?.mode ?? "lite"),
          },
        }}
      />
    </div>
  );
};

export default DateEnableSwitch;
